// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type RetryExportMutationVariables = Types.Exact<{
  executionId: Types.Scalars['String']['input'];
}>;

export type RetryExportMutation = { retryExport: { executionId: number } };

export const RetryExportDocument = gql`
    mutation RetryExport($executionId: String!) {
  retryExport(executionId: $executionId) {
    executionId
  }
}
    ` as unknown as DocumentNode<RetryExportMutation, RetryExportMutationVariables>;
